import { Link } from "react-router-dom/cjs/react-router-dom";
import TranslationText from "../Translation/TranslationText";

export function PasswordRecoveryLinks({ businessLogin }) {
	return (
		<div className="password-recovery-links">
			{
				!businessLogin ? (
					<Link className="link-button link-button-small" to="/PasswordRecovery/RemindEmail">
						<TranslationText text="login_page_remind_email_btn" />
					</Link>
				) : null
			}
			<Link
				className="link-button link-button-small"
				to={{
					pathname: "/PasswordRecovery/EnterEmail",
					state: { isBusinessLogin: businessLogin }
				}}
			>
				<TranslationText text="login_page_remind_password_btn" />
			</Link>
		</div>
	);
}